import React, { FC } from 'react';
import { Title } from '../developers/page-components/Title';
import { ProgressBar } from '../general-components/ProgressBar';
import { ProgressRange } from './ProgressRange';
import { numberFormatter } from '../../utils/utilities';
import clsx from 'clsx';
import { WhisperComponent } from '../developers/page-components/WhisperComponent';
import { VALUE_TYPE } from '../general-components/NumberFormatterComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfinity } from '@fortawesome/free-solid-svg-icons';

interface Props {
  type: VALUE_TYPE;
  maxValue: number;
  metric: number;
  mainAdditionalClass?: string;
}
export const TableProgressBar: FC<Props> = (props) => {
  const { maxValue, metric, type, mainAdditionalClass } = props;

  const percent = maxValue && metric ? (metric / maxValue) * 100 : 0;

  const getTitle = (): string | JSX.Element => {
    if (maxValue === null) {
      return <FontAwesomeIcon icon={faInfinity} width={12}/>;
    } else {
      return percent === 0 || Number.isInteger(percent) ? percent + '%' : numberFormatter(percent) + '%' ;
    }
  };

  const mainText = (
    <div className="d-flex flex-column align-items-center">
      <Title title={getTitle()} additionalClass={clsx('fs-9', percent >= 75 && 'text-danger')} />
      <ProgressBar percent={percent} />
      <ProgressRange
        maxValue={maxValue}
        metric={metric}
        type={type}
        additionalClass={mainAdditionalClass}
        shorterNumberFormat={true}
      />
    </div>
  );

  return (
    <WhisperComponent
      isTooltip
      whisperText={<ProgressRange maxValue={maxValue} metric={metric} type={type} />}
      mainText={mainText}
      additionalClass="cursor-help"
    />
  );
};